import Settings from '../domain/Settings';

type PerformanceMark = {
	name: string,
	entryType: string
	duration: number
	startTime: number
}

let profile: string;

const neededLogs = [
	 'privacy - start',
	 'core - ready',
	 'privacy - api available',
	 'privacy - tcData',
	 'xandr - apntag.cmd wait',
	 'xandr - slotmanager.extendSlots',
	 'prebid - requestBids'
]

export function init() {
	const settings = Settings.getInstance();

	if (settings.features?.performanceMonitoring && _isInSampleSize(settings.performanceMonitoring.sampleSize)) {
		profile = settings.debugInfo?.profile;
		document.addEventListener('visibilitychange', _onVisibilityChanged);
	}
}

function _onVisibilityChanged() {
	if (document.visibilityState === 'hidden') {
		navigator.sendBeacon(
			"https://ccfw2p4etlcat5q3y7ndlcxxha0ffvhk.lambda-url.eu-west-1.on.aws/",
			new Blob([JSON.stringify({
				"profile": profile ?? 'unknown',
				"target": "web",
				"measurements": _getPerformanceLogs()
			})], {type : 'application/json; charset=UTF-8'})
		);
	}
}

function _isInSampleSize(size: number): boolean {
	return Math.random() <= size;
}

export function _getPerformanceLogs(): Array<Array<string | number>> {
	return _getAllPerformanceLogs().reduce((agg, log) => {
		if (neededLogs.some(neededLog => log.name.includes(neededLog))) {
			agg.push([log.name, log.startTime])
		}

		return agg;
	}, []);
}

function _getAllPerformanceLogs(): Array<PerformanceMark> {
	return performance.getEntriesByType('mark')
		.filter((entry: PerformanceMark) => entry.name.indexOf('advert - ') === 0);
}

